/**
 * Thin client for santa_drop_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'santa_drop';

export const SANTA_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.santa_drop?.API_BASE || '')
    : '/santa';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Santa Drop GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

/** Optional `seed` (int) makes the run reproducible: same seed + same moves = same game. */
export async function createSantaSession(seed) {
    await acquireGmLease(GM_GAME_ID);
    const body = Number.isInteger(seed) ? { seed } : {};
    const res = await fetch(`${SANTA_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    return parseJson(res);
}

/** `action` is one action, or an array of queued ticks applied in order (tickBatcher.js). */
export async function moveSantaSession(sessionId, action) {
    const res = await fetch(`${SANTA_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Array.isArray(action) ? { actions: action } : { action }),
    });
    return parseJson(res);
}

/** Server cap on ticks per /move (santa_drop_gm.MAX_BATCH_TICKS). */
export const MAX_BATCH_TICKS = 40;

export async function deleteSantaSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${SANTA_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const GIFT_POINTS = 50;
export const LANE_COUNT = 5;
export const MAX_GIFTS = 20;
export const MAX_SCORE = GIFT_POINTS * MAX_GIFTS;
/** sled_pos at the start (field units); sled_x is the legacy lane 0-4. */
export const SLED_START_X = 90;
